import axios from 'axios';
import { getLoginOutShopId, getLoginShopInfo, isNotNull, systemConfig } from './http';
//阿里巴巴上报节点处理

//埋点基类
export const report = (offerids, pagekey, reportType, gmkey) => {
    try {
        //将offerids 转为 逗号分隔的string 
        if (offerids == undefined && offerids.length <= 0) {
            return;
        }
        var currentUrl = window.location.protocol + "//" + window.location.host;
        var shop = getLoginShopInfo();
        var platform = shop.loginShopPlatformType;

        var appkey = "8076003";
        var pageKey = platformConvert(platform) + "_" + pagekey;
        var reportUrl = "https://aliance.1688.com/acquisition/doReport.shtml";
        var userId = systemConfig.alibabaShopId;
        const timestamp = new Date().getTime();
        if (!isNotNull(userId)) {
            userId = getLoginOutShopId();
            if (!isNotNull(userId)) {
                return;
            }
        }
        var batchSize = 20;
        for (let i = 0; i < offerids.length; i += batchSize) {
            const batchIds = offerids.slice(i, i + batchSize);

            try {
                var offerId = batchIds.join(',');//商品id
                var gokey = `spm-pre=&spm-url=&spm-cnt=fxg_${appkey}.${pageKey}.0.0&${reportType.toLowerCase()}data=[{"exargs":{"expo_data":"object_id@${offerId}^object_type@offer^object_id@${appkey}^object_type@appKey^object_id@${timestamp}^object_type@timeStamp"},"spm":"fxg_${appkey}.${pageKey}.0.0"}]&_is_auto_exp=1&at_bu=cbu&platformType=pc&device_model=手机或终端的机型&language=zh-CN`;

                requests({
                    url: reportUrl,
                    data: {
                        'reportType': reportType,
                        'gmkey': gmkey,
                        '_p_url': currentUrl,
                        'pre_url': currentUrl,
                        'gokey': gokey,
                        'spm-cnt': 'fxg_' + appkey + '.' + pageKey + '.0.0',
                        '_gr_uid_': userId,
                        'uidplus': userId,
                        'logtype': '2'
                    },
                    success: (json) => {
                        //console.log(`批次 ${i/batchSize + 1} 提交成功:`+JSON.parse(json));
                    }
                });

            } catch (error) {
                console.error(`批次 ${i / batchSize + 1} 提交失败:`, error);
                // 这里可以添加失败重试逻辑
            }
        }
    } catch (error) {
        console.log('alibaba report 出错了：' + error);
    }


}

export const platformConvert = (platform) => {
    if (platform == "Taobao")
        return "thyny";
    if (platform == "TouTiao")
        return "douyin";
    if (platform == "Pinduoduo")
        return "pinduoduo";
    if (platform == "KuaiShou")
        return "kuaishou";
    if (platform == "WxVideo")
        return "shipinghao";
    if (platform == "XiaoHongShu")
        return "xiaohongshu";
    if (platform == "YouZan")
        return "youzan";
    if (platform == "KuaiTuanTuan")
        return "kuaituantuan";
    if (platform == "WeiMeng")
        return "weimeng";
    return platform.toLowerCase();
}


//扩展商品曝光
export const productExposureReport = (offerids, pagekey) => {
    report(offerids, pagekey, 'EXP', 'OFFER_EXP');
}

//其他展示曝光
export const otherExposureReport = (pagekey) => {
    try {
        var currentUrl = window.location.protocol + "//" + window.location.host;
        var shop = getLoginShopInfo();
        var platform = shop.loginShopPlatformType;

        var appkey = "8076003";
        var pageKey = platformConvert(platform) + "_" + pagekey;
        var reportUrl = "https://aliance.1688.com/acquisition/doReport.shtml";
        var userId = systemConfig.alibabaShopId;
        const timestamp = new Date().getTime();
        if (!isNotNull(userId)) {
            userId = getLoginOutShopId();
            if (!isNotNull(userId)) {
                return;
            }
        }



        var gokey = `spm-pre=&spm-url=&spm-cnt=fxg_${appkey}.${pageKey}.0.0&expdata=[{"exargs":{"expo_data":"object_id@^object_type@offer^object_id@${appkey}^object_type@appKey^object_id@${timestamp}^object_type@timeStamp"},"spm":"fxg_${appkey}.${pageKey}.0.0"}]&_is_auto_exp=1&at_bu=cbu&platformType=pc&device_model=手机或终端的机型&language=zh-CN`;

        requests({
            url: reportUrl,
            data: {
                'reportType': 'EXP',
                'gmkey': 'OTHER',
                '_p_url': currentUrl,
                'pre_url': currentUrl,
                'gokey': gokey,
                'spm-cnt': 'fxg_' + appkey + '.' + pageKey + '.0.0',
                '_gr_uid_': userId,
                'uidplus': userId,
                'logtype': '2',
            },
            success: (json) => {
                //console.log(`批次 ${i/batchSize + 1} 提交成功:`+JSON.parse(json));
            }
        });
    } catch (error) {
        console.log('alibaba report 出错了：' + error);
    }
}


//点击曝光
export const otherClickExposureReport = (pagekey, key) => {
    try {
        var currentUrl = window.location.protocol + "//" + window.location.host;
        var shop = getLoginShopInfo();
        var platform = shop.loginShopPlatformType;

        var appkey = "8076003";
        var pageKey = platformConvert(platform) + "_" + pagekey;
        var reportUrl = "https://aliance.1688.com/acquisition/doReport.shtml";
        var userId = systemConfig.alibabaShopId;
        const timestamp = new Date().getTime();
        if (!isNotNull(userId)) {
            userId = getLoginOutShopId();
            if (!isNotNull(userId)) {
                return;
            }
        }

        var gokey = `spm-pre=&spm-url=&spm-cnt=fxg_${appkey}.${pageKey}.0.0&clkdata=[{"exargs":{"expo_data":"object_id@^object_type@offer^object_id@${appkey}^object_type@appKey^object_id@${timestamp}^object_type@timeStamp"},"spm":"fxg_${appkey}.${pageKey}.0.0"}]&_is_auto_exp=1&at_bu=cbu&platformType=pc&device_model=手机或终端的机型&language=zh-CN`;

        requests({
            url: reportUrl,
            data: {
                'reportType': 'CLK',
                'gmkey': key,
                '_p_url': currentUrl,
                'pre_url': currentUrl,
                'gokey': gokey,
                'spm-cnt': 'fxg_' + appkey + '.' + pageKey + '.0.0',
                '_gr_uid_': userId,
                'uidplus': userId,
                'logtype': '2',
            },
            success: (json) => {
                //console.log(`批次 ${i/batchSize + 1} 提交成功:`+JSON.parse(json));
            }
        });
    } catch (error) {
        console.log('alibaba report 出错了：' + error);
    }
}

//商品点击
export const productClickReport = (offerids, pagekey) => {
    report(offerids, pagekey, 'CLK', 'OFFER_CLK');
}

//铺货点击
export const prodctDitributionClickReport = (offerids, pagekey) => {
    report(offerids, pagekey, 'CLK', 'DISTRIBUTE_CLK');
}


export const requests = (options) => {
    return axios.get(options.url, {
        params: options.data
    }).then((res) => {
        console.log("alibaba report return:" + JSON.parse(res));
        //options.success(dates)

    }).catch(err => { if (options.fail) options.fail(err) })

}



// WEBPACK FOOTER //
// ./src/utils/alibabareport.js